
import { iconFactory } from '../../utils/iconFactory';

export const CloseIcon = iconFactory({
  componentName: 'CloseIcon',
  viewBox: '0 0 32 32',
  title: 'close',
  g: `<path d="M18.332 16l7.901 7.903-2.332 2.332-7.901-7.903-7.903 7.903-2.332-2.332 7.903-7.903-7.903-7.903 2.332-2.332 7.903 7.903 7.903-7.903 2.332 2.332-7.903 7.903z"/>`,
  gThemed: {
    // other themes are not available
  }
});

export default CloseIcon;
